import { useEffect, useState } from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import {
  ConnectComponentsProvider, ConnectAccountOnboarding, ConnectPayouts,
  ConnectAccountManagement, ConnectNotificationBanner, ConnectBalances,
} from "@stripe/react-connect-js";
import client from "../lib/api";

export default function EmbeddedPayouts({ mode = "onboarding", sessionPath = "/connect/account-session", onDone }) {
  const [instance, setInstance] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: cfg } = await client.get("/connect/config");
        if (!cfg.publishable_key) { setErr("Payouts aren't configured yet."); return; }
        const inst = loadConnectAndInitialize({
          publishableKey: cfg.publishable_key,
          fetchClientSecret: async () => {
            const r = await client.post(sessionPath);
            return r.data.client_secret;
          },
          appearance: { variables: { colorPrimary: "#4A0000", borderRadius: "8px" } },
        });
        if (!cancelled) setInstance(inst);
      } catch (e) {
        if (!cancelled) setErr(e.response?.data?.detail || "Could not load payout view");
      }
    })();
    return () => { cancelled = true; };
  }, [sessionPath]);

  if (err) return <p className="text-sm text-red-600" data-testid="embedded-payouts-error">{err}</p>;
  if (!instance) return <p className="text-sm text-[#5C5A58]" data-testid="embedded-payouts-loading">Loading secure payout view…</p>;

  return (
    <div data-testid="embedded-payouts">
      <ConnectComponentsProvider connectInstance={instance}>
        {mode === "onboarding" && <ConnectAccountOnboarding onExit={() => onDone && onDone()} />}
        {mode === "manage" && (
          <div className="space-y-6">
            <ConnectNotificationBanner />
            <ConnectPayouts />
            <ConnectAccountManagement />
          </div>
        )}
        {mode === "admin" && (
          <div className="space-y-6">
            <ConnectNotificationBanner />
            <ConnectBalances />
            <ConnectPayouts />
            <ConnectAccountManagement />
          </div>
        )}
      </ConnectComponentsProvider>
    </div>
  );
}
